import type {
  AccountProfile,
  CoinPackage,
  DiscordWidget,
  DownloadMetadata,
  EventSchedule,
  GameCharacter,
  MarketplaceListing,
  NewsPost,
  RankingGuild,
  RankingPlayer,
  ServerStatus,
  TransactionRecord,
  VanguardCoinBalance,
} from './contracts'

/**
 * Presentation-only values that preserve the current visual composition.
 * Replace these exports with backend data adapters; they are not live records.
 */
export const presentationServerStatus: ServerStatus = {
  health: 'development',
  label: 'Servidor en Desarrollo',
  onlinePlayers: 3,
  uptimePercent: 99.9,
  latencyMs: 12,
}

export const presentationRankings: RankingPlayer[] = [
  {
    rank: 1,
    characterName: 'VANGUARD',
    characterClass: 'Blade Knight',
    level: 400,
    resets: 150,
  },
  {
    rank: 2,
    characterName: 'ESCANOR',
    characterClass: 'Grand Master',
    level: 400,
    resets: 148,
  },
  {
    rank: 3,
    characterName: 'BASTION',
    characterClass: 'Dark Lord',
    level: 400,
    resets: 145,
  },
  {
    rank: 4,
    characterName: 'LEONIDAS',
    characterClass: 'Rage Fighter',
    level: 398,
    resets: 140,
  },
  {
    rank: 5,
    characterName: 'SENTINEL',
    characterClass: 'Dark Lord',
    level: 395,
    resets: 138,
  },
]

export const presentationGuildRankings: RankingGuild[] = [
  {
    rank: 1,
    guildName: 'IMPERIUM',
    guildMaster: 'VANGUARD',
    members: 80,
    score: 15420,
  },
  {
    rank: 2,
    guildName: 'LEGENDS',
    guildMaster: 'ESCANOR',
    members: 75,
    score: 14850,
  },
  {
    rank: 3,
    guildName: 'TITANS',
    guildMaster: 'BASTION',
    members: 72,
    score: 13920,
  },
  {
    rank: 4,
    guildName: 'SPARTANS',
    guildMaster: 'LEONIDAS',
    members: 68,
    score: 12750,
  },
  {
    rank: 5,
    guildName: 'GUARDIANS',
    guildMaster: 'SENTINEL',
    members: 65,
    score: 11980,
  },
]

export const presentationAccountProfile: AccountProfile = {
  accountId: 'presentation-account',
  username: 'Account user',
  email: 'account@example.com',
  registrationDate: '2025-01-15',
  isVip: true,
  playTime: '450h 23m',
  kills: 12450,
  deaths: 342,
}

export const presentationCoinBalance: VanguardCoinBalance = {
  available: 32500,
  currency: 'V Coin',
  exchangeRateToUsdt: 0.01,
}

export const presentationCharacters: GameCharacter[] = [
  {
    id: 'character-shadowblade',
    name: 'ShadowBlade',
    characterClass: 'Blade Knight',
    level: 400,
    resets: 50,
    server: 'Vanguard-1',
    location: 'Icarus (45, 210)',
  },
  {
    id: 'character-mysticsoul',
    name: 'MysticSoul',
    characterClass: 'Soul Master',
    level: 350,
    resets: 25,
    server: 'Vanguard-1',
    location: 'Tarkan (120, 150)',
  },
]

export const presentationCoinPackages: CoinPackage[] = [
  { id: 'package-100', amount: 100, priceUsd: 10, bonus: 0 },
  { id: 'package-500', amount: 500, priceUsd: 45, bonus: 50 },
  { id: 'package-1000', amount: 1000, priceUsd: 80, bonus: 150 },
  { id: 'package-5000', amount: 5000, priceUsd: 350, bonus: 1000 },
]

export const presentationTransactions: TransactionRecord[] = [
  {
    id: 'transaction-001',
    type: 'deposit',
    amount: 500,
    currency: 'V Coin',
    status: 'completed',
    createdAt: '2026-04-20',
  },
  {
    id: 'transaction-002',
    type: 'withdrawal',
    amount: 100,
    currency: 'V Coin',
    status: 'pending',
    createdAt: '2026-04-18',
  },
]

export const presentationNews: NewsPost[] = [
  {
    id: 'news-launch',
    publishedAt: '2026-04-20',
    title: 'Gran Lanzamiento Oficial',
    excerpt:
      '¡Las puertas finalmente se abren! Únete a nosotros para la gran apertura oficial de MU Vanguard.',
    category: 'Anuncio',
    imageUrl:
      'https://cdn.magicpatterns.com/uploads/6hvWMPRcrc7W6dReYQu3EU/image0.png',
  },
]

export const presentationEvents: EventSchedule[] = [
  {
    id: 'event-battle-royale',
    title: 'Battle Royale',
    startsAt: null,
    rewardSummary: 'V Coin rewards',
    status: 'upcoming',
  },
]

export const presentationMarketplace: MarketplaceListing[] = [
  {
    id: 'marketplace-placeholder',
    itemName: 'Marketplace item',
    sellerName: 'Player',
    price: 0,
    currency: 'V Coin',
  },
]

export const presentationDownload: DownloadMetadata = {
  clientVersion: 'Full Version',
  fileSize: '1.2 GB',
  clientUrl: null,
  installationGuideUrl: null,
}

export const presentationDiscord: DiscordWidget = {
  inviteUrl: null,
  onlineMembers: null,
  widgetEnabled: false,
}
